/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Frost_Free_Activated_By_All_RoomsInputs */



/**
* | output |
* | --- |
* | "Frost-free mode activated in all rooms" |
*
* @param {Frost_Free_Activated_By_All_RoomsInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const frost_free_activated_by_all_rooms = /** @type {((inputs?: Frost_Free_Activated_By_All_RoomsInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Frost_Free_Activated_By_All_RoomsInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Frost-free mode activated in all rooms")
	return /** @type {LocalizedString} */ ("Mode HG activé dans toutes les pièces")
});